export enum EDropdownStyleType {
  Primary = "primary",
  Secondary = "secondary",
  Clean = "clean",
}
